import React from "react";

import { Action, BasketballActionType, HockeyActionType, SoccerActionLineType } from "../../types";
import { BlockLine } from "./block-line";
import { DottedLine } from "./dotted-line";
import { Handoff } from "./handoff";
import { Hashpass } from "./hashpass";
import { Shoot } from "./shoot";
import { SkateBackwards } from "./skate-backwards";
import { SolidLine } from "./solid-line";
import { SquiggleLine } from "./squiggle-line";

export interface ActionProps {
  action: Action;
  strokeWidth?: number;
  animateable?: boolean;
}

export const ActionLineRenderer = ({ action, strokeWidth = 0.3, animateable = false }: ActionProps): JSX.Element => {
  switch (action.layerType) {
    case BasketballActionType.CUT:
    case HockeyActionType.SKATE:
    case SoccerActionLineType.SC_PASS:
      return (
        <SolidLine
          action={action}
          controlPoints={action.midPoints}
          strokeWidth={strokeWidth}
          animateable={animateable}
        />
      );

    case HockeyActionType.SKATE_BACKWARDS:
      return (
        <SkateBackwards
          action={action}
          controlPoints={action.midPoints}
          size={0.25}
          strokeWidth={strokeWidth}
          animateable={animateable}
        />
      );

    case BasketballActionType.PASS:
    case HockeyActionType.PASS:
    case SoccerActionLineType.SC_RUN:
    case SoccerActionLineType.SC_RUN_AND_STOP:
      return (
        <DottedLine
          action={action}
          controlPoints={action.midPoints}
          strokeWidth={strokeWidth}
          animateable={animateable}
        />
      );

    case HockeyActionType.SHOOT:
    case SoccerActionLineType.SC_SHOT:
      return (
        <Shoot action={action} controlPoints={action.midPoints} strokeWidth={strokeWidth} animateable={animateable} />
      );

    case BasketballActionType.SCREEN:
      return (
        <BlockLine
          action={action}
          controlPoints={action.midPoints}
          strokeWidth={strokeWidth}
          animateable={animateable}
        />
      );

    case BasketballActionType.DRIBBLE:
    case HockeyActionType.SKATE_WITH_PUCK:
    case HockeyActionType.SKATE_BACKWARDS_WITH_PUCK:
    case SoccerActionLineType.SC_DRIBBLE:
    case SoccerActionLineType.SC_DRIBBLE_AND_STOP:
      return (
        <SquiggleLine
          action={action}
          controlPoints={action.midPoints}
          strokeWidth={strokeWidth}
          animateable={animateable}
        />
      );

    case BasketballActionType.HASHPASS:
      return (
        <Hashpass
          action={action}
          numberOfHashes={action.numberOfHashes}
          strokeWidth={strokeWidth}
          animateable={animateable}
        />
      );

    case BasketballActionType.HANDOFF:
    case HockeyActionType.HANDOFF:
    case SoccerActionLineType.SC_HANDOFF:
      return <Handoff strokeWidth={strokeWidth} />;

    case BasketballActionType.CUT_RECEIVING_HANDOFF:
    case BasketballActionType.SCREEN_RECEIVING_HANDOFF:
    case HockeyActionType.SKATE_BACKWARDS_RECEIVING_HANDOFF:
    case HockeyActionType.SKATE_LATERAL:
    case HockeyActionType.SKATE_LATERAL_RECEIVING_HANDOFF:
    case HockeyActionType.SKATE_RECEIVING_HANDOFF:
    case SoccerActionLineType.SC_RUN_AND_STOP_RECEIVING_HANDOFF:
    case SoccerActionLineType.SC_RUN_RECEIVING_HANDOFF:
      return (
        <SolidLine
          action={action}
          controlPoints={action.midPoints}
          strokeWidth={strokeWidth}
          animateable={animateable}
        />
      );
  }
};
